import React, { useReducer, useContext, useLayoutEffect } from 'react'
import { lockedReducer } from '../../Utils/reducers'
import { api } from '../../../services/api'
import ColorButton from '../../Buttons/ColorButton';
import DefaultModal from '../../Utils/DefaultModal';
import toast from 'react-hot-toast'
import { Box, Tooltip, TextField, List, ListItem, ListItemText, ListItemAvatar, Avatar } from '@mui/material'
import validateData from './validateData';
import { externalComponent } from '../../AppRoutes';
import { avatars } from '.';
import dayjs from 'dayjs'


const url = '/function_log/'

export const translate_permissions_keys = {
    'Can': '',
    'add': 'Adicionar',
    'change': 'Alterar',
    'delete': 'Excluir',
    'view': 'Ver'
}


const getTitle = (data) => {
    if (data?.id)
        return 'Editar'
    return 'Adicionar'
}

const initialize = async (id, setState, setLoader) => {
    setLoader(true)
    const res = await api.get(url + id + '/')
    if (res.status === 200) {
        setState(res.data)
    }
    setLoader(false)
}

const decideData = (key, value) => {
    switch (key) {
        case 'Iniciando':
            return dayjs(value).format('DD/MM/YYYY HH:mm')
        case 'Finalizado':
            return ''
        case 'Adicionado':
            return value.map(each => `${each.cnpj} - ${each.status}`).join('\n')
        default:
            return value
    }
}

const EditFunctionLogsModal = ({ data, handleClose, permissions, reloadData }) => {

    const { setLoader } = useContext(externalComponent)

    const [state, setState] = useReducer(lockedReducer, {
        id: data.id ? data.id : 0,
        name: data.name ? data.name : '',
        log_content: data.log_content ? data.log_content : { events: [] },
    })

    useLayoutEffect(() => {
        initialize(data.id, setState, setLoader)
    }, [])

    const validData = validateData(state)

    return (
        <>
            <DefaultModal
                title={
                    `${getTitle(state)} Logs de execução`
                }
                handleClose={handleClose}
                content={
                    <>
                        <Box className='item-content-modal noborder' sx={{ overflow: 'hidden' }} >
                            <Box className='item-profile-row'>
                                <TextField
                                    id="name"
                                    type="text"
                                    label="Nome"
                                    disabled
                                    value={state.name}
                                    onChange={(e) => { setState({ 'name': e.target.value }) }}
                                    fullWidth={false}
                                    size='small'
                                    inputProps={{
                                        maxLength: 50
                                    }}
                                />
                            </Box>

                            <Box className='item-profile-row' sx={{ overflow: 'auto' }}>
                                <List className='execution_logs-events-list' sx={{ width: '100%' }}>
                                    {Object.entries(state.log_content).map(([key, value]) => (
                                        <ListItem>
                                            {/* <ListItemAvatar>
                                            <Avatar>
                                                {avatars[event.event_type]}
                                            </Avatar>
                                        </ListItemAvatar> */}
                                            <Tooltip title={key} placement="bottom-start"
                                                PopperProps={{ modifiers: [{ name: "offset", options: { offset: [0, -15], }, }] }}>
                                                <ListItemText sx={{whiteSpace: 'pre'}} primary={key} secondary={decideData(key, value)} />
                                            </Tooltip>
                                        </ListItem>
                                    ))}
                                </List>
                            </Box>
                        </Box>
                    </>
                }
            />
        </>
    )
}

export default EditFunctionLogsModal